<template>
  <div id="featureDarkModeRoot" :style="backgroundAnimation">
    <div id="container">
      <div id="switchIconContainer">
        <SwitchThumb :show="color"/>
      </div>
      <div id="middleContainer">
        <FeatureInfoContainerCard v-on:is-expanded="toggle" style="justify-items:start;  width: 100%"
                                  :icon-color="'#FDFDFA'"
                                  :open-icon-position="iconPosition" background-color="#111411">
          <div id="middleContent">
            <transition name="fade">
              <div v-if="!expanded" id="title"><span v-html="content[0].title"></span></div>
            </transition>
            <transition name="fade">
              <div v-if="!expanded" id="description">
                <span v-html="content[0].description"></span></div>
            </transition>
            <transition name="fade">
              <div v-if="expanded" id="expandedDescription"><span
                  v-html="content[0].expandedDescription"></span></div>
            </transition>
          </div>
        </FeatureInfoContainerCard>
      </div>
      <div id="contentContainer">
        <img :src="require('../../assets/' + content[0].media)" @contextmenu.prevent/>
      </div>
    </div>
  </div>
</template>

<script>
import SwitchThumb from "../icons/SwitchThumb";
import FeatureInfoContainerCard from "./FeatureInfoContainerCard";

export default {
  name: "FeatureDarkModeCard",
  components: {SwitchThumb, FeatureInfoContainerCard},
  props: {
    height: {
      type: Number,
      default: 0
    },

    name: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    taglineDescription: {
      type: String,
      default: ""
    },
    tagline: {
      type: String,
      default: ""
    },
    content: {
      type: Array,
    },
  },
  data() {
    return {
      expanded: false
    }
  },
  computed: {
    backgroundAnimation() {
      if (this.color) {
        return {
          'background-color': `#000300`,
          transition: `0.6s ease-in-out !important`,
          '-webkit-transition': `0.6s ease-in-out !important`,
          '-o-transition': `0.6s ease-in-out !important`,
          '-moz-transition': `0.6s ease-in-out !important`
        }
      } else {
        return {
          'background-color': `#FDFDFA`,
          transition: `0.4s ease-in-out !important`,
          '-webkit-transition': `0.4s ease-in-out !important`,
          '-o-transition': `0.4s ease-in-out !important`,
          '-moz-transition': `0.4s ease-in-out !important`
        }
      }
    },
    offset() {
      return this.$store.state.scrollOffset
    },
    color() {
      if (this.height > 844)
        return this.offset > (this.height * 5.6)
      else if (this.height > 812 && this.height <= 844) // iphone 12
        return this.offset > (this.height * 7.6)
      else
        return this.offset > (this.height * 8.2)

    },
    iconPosition() {
      if (this.height > 812)
        return 3
      else
        return 1
    }
  },
  methods: {
    toggle(value) {
      this.$gtag.event('featureToggle', {
        eventCategory: 'dark_theme',
        eventAction: 'click',
        eventValue: value ? 1 : 0
      })
      this.expanded = value
    },
  },

}
</script>

<style lang="scss" src="../../styles/featuredarkmodecard.scss" scoped/>